import { NgModule } from '@angular/core';
import { KeyValuePipe } from "./keyvalue/keyvalue";
import { DateTimePipe } from "./keyvalue/dateTime";
import { SafeHtmlPipe } from "./safe-html/safe-html";
import { AiStatusTextPipe } from "./status-text/ai-status-text.pipe";

@NgModule({
    declarations: [KeyValuePipe, DateTimePipe, SafeHtmlPipe, AiStatusTextPipe],
    imports: [],
    exports: [KeyValuePipe, DateTimePipe, SafeHtmlPipe, AiStatusTextPipe],
})
export class PipesModule { }
